<div class="py-24 sm:py-32">
  <div
    class="max-w-3xl mx-auto px-6 py-8 font-sans text-gray-800 leading-relaxed"
    @fadeIn
  >
    <h1 class="text-4xl font-bold text-gray-900 mb-4">{{ 'terms_of_service.title' | translate }}</h1>
    <p class="text-sm text-gray-600 italic mb-8">
      {{ 'terms_of_service.last_updated' | translate:{ date: currentDate | date:'longDate' } }}
    </p>

    <div @staggerSections>
      <section class="mb-8 pb-8 border-b border-gray-200 last:border-b-0">
        <h2 class="text-2xl font-semibold text-gray-800 mb-4">{{ ('terms_of_service.content.sections' | translate)[0].number }}. {{ ('terms_of_service.content.sections' | translate)[0].title }}</h2>
        <p class="mb-4">
          {{ 'terms_of_service.content.introduction' | translate }}
        </p>
      </section>

      <section class="mb-8 pb-8 border-b border-gray-200 last:border-b-0">
        <h2 class="text-2xl font-semibold text-gray-800 mb-4">{{ ('terms_of_service.content.sections' | translate)[1].number }}. {{ ('terms_of_service.content.sections' | translate)[1].title }}</h2>
        <p class="mb-4">
          {{ 'terms_of_service.content.changes' | translate }}
        </p>
      </section>

      <section class="mb-8 pb-8 border-b border-gray-200 last:border-b-0">
        <h2 class="text-2xl font-semibold text-gray-800 mb-4">{{ ('terms_of_service.content.sections' | translate)[2].number }}. {{ ('terms_of_service.content.sections' | translate)[2].title }}</h2>
        <p class="mb-4">
          {{ 'terms_of_service.content.account' | translate }}
        </p>
      </section>

      <section class="mb-8 pb-8 border-b border-gray-200 last:border-b-0">
        <h2 class="text-2xl font-semibold text-gray-800 mb-4">{{ ('terms_of_service.content.sections' | translate)[3].number }}. {{ ('terms_of_service.content.sections' | translate)[3].title }}</h2>
        <p class="mb-4">
          {{ 'terms_of_service.content.usage' | translate }}
        </p>
      </section>

      <section class="mb-8 pb-8 border-b border-gray-200 last:border-b-0">
        <h2 class="text-2xl font-semibold text-gray-800 mb-4">{{ ('terms_of_service.content.sections' | translate)[4].number }}. {{ ('terms_of_service.content.sections' | translate)[4].title }}</h2>
        <p class="mb-4">
          {{ 'terms_of_service.content.termination' | translate }}
        </p>
      </section>

      <section class="mb-8 pb-8 border-b border-gray-200 last:border-b-0">
        <h2 class="text-2xl font-semibold text-gray-800 mb-4">
          {{ ('terms_of_service.content.sections' | translate)[5].number }}. {{ ('terms_of_service.content.sections' | translate)[5].title }}
        </h2>
        <p class="mb-4">
          {{ 'terms_of_service.content.accuracy' | translate }}
        </p>
      </section>

      <section class="mb-8 pb-8 border-b border-gray-200 last:border-b-0">
        <h2 class="text-2xl font-semibold text-gray-800 mb-4">{{ ('terms_of_service.content.sections' | translate)[6].number }}. {{ ('terms_of_service.content.sections' | translate)[6].title }}</h2>
        <p class="mb-4">
          {{ 'terms_of_service.content.links' | translate }}
        </p>
      </section>

      <section class="mb-8 pb-8 border-b border-gray-200 last:border-b-0">
        <h2 class="text-2xl font-semibold text-gray-800 mb-4">
          {{ ('terms_of_service.content.sections' | translate)[7].number }}. {{ ('terms_of_service.content.sections' | translate)[7].title }}
        </h2>
        <p class="mb-4">
          {{ 'terms_of_service.content.modifications' | translate }}
        </p>
      </section>

      <section class="mb-8 pb-8 border-b border-gray-200 last:border-b-0">
        <h2 class="text-2xl font-semibold text-gray-800 mb-4">
          {{ ('terms_of_service.content.sections' | translate)[8].number }}. {{ ('terms_of_service.content.sections' | translate)[8].title }}
        </h2>
        <p class="mb-4">
          {{ 'terms_of_service.content.governing_law' | translate }}
        </p>
      </section>

      <section class="mb-8 pb-8">
        <h2 class="text-2xl font-semibold text-gray-800 mb-4">
          {{ ('terms_of_service.content.sections' | translate)[9].number }}. {{ ('terms_of_service.content.sections' | translate)[9].title }}
        </h2>
        <p class="mb-4">
          {{ 'terms_of_service.content.contact.description' | translate }}
        </p>
        <p class="text-gray-700">{{ 'terms_of_service.content.contact.info' | translate }}</p>
      </section>
    </div>
  </div>
</div>
